module.exports = __webpack_public_path__ + "static/advice7-9597b783c06d1b63f78739372db5091f.png";